import { render } from "./AdminSidebox.vue?vue&type=template&id=05ab1d54"
import script from "./AdminSidebox.vue?vue&type=script&lang=js"
export * from "./AdminSidebox.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__